import { ThemeUICSSObject } from '@apia/theme';
/* IMPORT HERE */
export const controller: ThemeUICSSObject = {
  /* PREPEND HERE */

  display: 'flex',
  flexDirection: 'column',
  alignItems: 'stretch',
  maxHeight: '50vh',
  gap: 3,
  flexBasis: '50vh',

  '.autoscrollContainer': {
    flexGrow: 1,
    flexShrink: 1,
  },

  '.search_controls': {
    flexShrink: 0,
  },
};
